import { render, staticRenderFns } from "./SearchBarFilterAI.vue?vue&type=template&id=38489901&scoped=true"
import script from "./SearchBarFilterAI.vue?vue&type=script&lang=js"
export * from "./SearchBarFilterAI.vue?vue&type=script&lang=js"
import style0 from "./SearchBarFilterAI.vue?vue&type=style&index=0&id=38489901&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38489901",
  null
  
)

export default component.exports